<template lang="pug">
  .toggle-height
    slot(name="top" :toggle="toggle" :val="val")
    
    .toggle-area(ref="toggleArea" :style="{maxHeight: maxHeight, transitionDuration: transitionDuration, visibility: visibility }")
      .toggle-area-inner(ref="toggleAreaInner")
        slot(name="bottom" :toggle="toggle" :val="val")

</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: "ToggleHeight",

    props: {
      initialVal: {
        type: Number,
        default: 0
      }
    },
    
    data() {
      return {
        val: 0,
        maxHeight: 0,
        transitionDuration: '300ms',
        visibility: 'hidden',
        timeout: null,
        resizeObserver: null,
      };
    },

    computed: {
      ...mapState('global', ['windowData']),
    },

    watch: {
      initialVal() {
        if (this.initialVal != this.val) {
          this.toggle();
        }
      },

      windowData: {
        handler() {
          this.adjustHeight();
        },
        deep: true
      }
    },

    mounted() {
      this.resizeObserver = new ResizeObserver(() => {
        this.adjustHeight();
      });
      this.resizeObserver.observe(this.$refs.toggleAreaInner);
      
      if (this.initialVal == 1) {
        this.toggle();
      }
    },

    beforeUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    },

    methods: {
      toggle() {
        if (this.val == 0) {
          this.val = 1;
          this.maxHeight = this.$refs.toggleAreaInner.clientHeight + 'px';
        } else {
          this.val = 0;
          this.maxHeight = 0;
        }

        let duration = 300;

        if (this.$refs.toggleAreaInner.clientHeight > 1050) {
          duration = this.$refs.toggleAreaInner.clientHeight/3.5;
        }

        this.transitionDuration = duration + 'ms';

        if (this.val) {
          this.visibility = 'visible';
          clearTimeout(this.timeout);
        } else {
          this.timeout = setTimeout(() => {
            this.visibility = 'hidden';
          }, duration);
        }
      },

      adjustHeight() {
        if (this.val == 1) {
          this.maxHeight = this.$refs.toggleAreaInner.clientHeight + 'px';
        }
      }
    }
  };
</script>

<style scoped lang="stylus">
  .toggle-height
    .toggle-area
      overflow hidden
      transition max-height 350ms ease-in-out
      
</style>
